import XLSX from "xlsx";
// import XLSXStyle from "xlsx-style";
import { saveAs } from "file-saver";

function exportToExcel(list, fileName, tabledData, delEnd) {
  let arr = JSON.parse(JSON.stringify(list));
  if (delEnd.length > 0) {
    delEnd.forEach(item => {
      arr.forEach((itemA, indexA) => {
        if (
          item == itemA.key ||
          item == itemA.slot ||
          (!itemA.key && !item.slot)
        ) {
          console.log(indexA);
          arr.splice(indexA, 1);
        }
      });
    });
  }
  let columns = arr;
  let columnsWidth = [];
  let filterVal = arr;
  let filterKeys = [];
  filterVal.map(item => {
    columnsWidth.push(item.width - 100);
    filterKeys.push(item.key);
  });
  let tHeader = buildHeader(columns);
  let rows = tHeader.length;
  // 计算合并
  let dataList = formatJson(filterKeys, tabledData);
  dataList.unshift(...tHeader); //标题
  let merges = doMerges(dataList);
  exprotData(dataList, fileName, columnsWidth, merges, rows);
  dataList = null;
  arr = null;
  columns = null;
  filterVal = null;
  filterKeys = null;
}
function exprotData(data, fileName, columnsWidth, merges, rows) {
  let workbook = XLSX.utils.book_new();
  // 生成sheet
  let ws = aoa_to_sheet(data, rows);
  // 宽度
  ws["!cols"] = [];
  columnsWidth.forEach(item => {
    let obj = { wpx: 100 };
    if (item) {
      obj.wpx = item;
    }
    ws["!cols"].push(obj);
  });
  // 单元格合并
  ws["!merges"] = merges;
  // 头部冻结
  ws["!freeze"] = {
    xSplit: "1",
    ySplit: "" + rows,
    topLeftCell: "B" + (rows + 1),
    activePane: "bottomRight",
    state: "frozen"
  };
  // excel样式
  let wopts = {
    bookType: "xlsx",
    bookSST: false,
    type: "binary",
    cellStyles: true
  };
  !fileName ? (fileName = "sheet") : "";
  // 将工作表添加到工作簿
  XLSX.utils.book_append_sheet(workbook, ws, "Sheet1");
  let wbout = XLSX.write(workbook, wopts);
  // 字符串转ArrayBuffer
  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }
  // 保存文件
  saveAs(
    new Blob([s2ab(wbout)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }),
    `${fileName}.xlsx`
  );
}
function formatJson(filterVal, jsonData) {
  return jsonData.map(v =>
    filterVal.map(j => {
      return v[j];
    })
  );
}
function buildHeader(revealList) {
  let excelHeader = [];
  // 构建生成excel表头需要的数据结构
  getHeader(revealList, excelHeader, 0, 0);
  // 多行表头长短不一，短的向长的看齐，不够的补上行合并占位符
  let max = Math.max(...excelHeader.map(a => a.length));
  excelHeader
    .filter(e => e.length < max)
    .forEach(e => pushRowSpanPlaceHolder(e, max - e.length));
  return excelHeader;
}
function getHeader(headers, excelHeader, deep, perOffset) {
  let offset = 0;
  let cur = excelHeader[deep];
  if (!cur) {
    cur = excelHeader[deep] = [];
  }
  // 填充行合并占位符
  pushRowSpanPlaceHolder(cur, perOffset - cur.length);
  for (let i = 0; i < headers.length; i++) {
    let head = headers[i];
    cur.push(head.title);
    if (
      head.hasOwnProperty("children") &&
      Array.isArray(head.children) &&
      head.children.length > 0
    ) {
      let childOffset = getHeader(
        head.children,
        excelHeader,
        deep + 1,
        cur.length - 1
      );
      // 填充列合并占位符
      pushColSpanPlaceHolder(cur, childOffset - 1);
      offset += childOffset;
    } else {
      offset++;
    }
  }
  return offset;
}
//  合并头部单元格
function doMerges(arr) {
  // 要么横向合并 要么纵向合并
  let deep = arr.length;
  let merges = [];
  for (let y = 0; y < deep; y++) {
    // 先处理横向合并
    let row = arr[y];
    let colSpan = 0;
    for (let x = 0; x < row.length; x++) {
      if (row[x] === "!$COL_SPAN_PLACEHOLDER") {
        row[x] = undefined;
        if (x + 1 === row.length) {
          merges.push({ s: { r: y, c: x - colSpan - 1 }, e: { r: y, c: x } });
        }
        colSpan++;
      } else if (colSpan > 0 && x > colSpan) {
        merges.push({ s: { r: y, c: x - colSpan - 1 }, e: { r: y, c: x - 1 } });
        colSpan = 0;
      } else {
        colSpan = 0;
      }
    }
  }
  // 再处理纵向合并
  let colLength = arr[0].length;
  for (let x = 0; x < colLength; x++) {
    let rowSpan = 0;
    for (let y = 0; y < deep; y++) {
      if (arr[y][x] === "!$ROW_SPAN_PLACEHOLDER") {
        arr[y][x] = undefined;
        if (y + 1 === deep) {
          merges.push({ s: { r: y - rowSpan, c: x }, e: { r: y, c: x } });
        }
        rowSpan++;
      } else if (rowSpan > 0 && y > rowSpan) {
        merges.push({ s: { r: y - rowSpan - 1, c: x }, e: { r: y - 1, c: x } });
        rowSpan = 0;
      } else {
        rowSpan = 0;
      }
    }
  }
  return merges;
}
// 填充列合并占位符
function pushColSpanPlaceHolder(arr, count) {
  for (let i = 0; i < count; i++) {
    arr.push("!$COL_SPAN_PLACEHOLDER");
  }
}
//  填充行合并占位符
function pushRowSpanPlaceHolder(arr, count) {
  for (let i = 0; i < count; i++) {
    arr.push("!$ROW_SPAN_PLACEHOLDER");
  }
}
// 设置单元格样式
function aoa_to_sheet(data, headerRows) {
  const ws = {};
  const range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
  for (let R = 0; R !== data.length; ++R) {
    for (let C = 0; C !== data[R].length; ++C) {
      if (range.s.r > R) {
        range.s.r = R;
      }
      if (range.s.c > C) {
        range.s.c = C;
      }
      if (range.e.r < R) {
        range.e.r = R;
      }
      if (range.e.c < C) {
        range.e.c = C;
      }
      /// 这里生成cell的时候，使用上面定义的默认样式
      const cell = {
        v: data[R][C] || "",
        s: {
          font: {
            name: "宋体",
            sz: 10,
            color: {
              auto: 1
            }
          },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } }
          },
          alignment: {
            /// 自动换行
            wrapText: 1,
            // 居中
            horizontal: "center",
            vertical: "center",
            indent: 0
          }
        }
      };
      // 头部列表加边框
      if (R < headerRows) {
        cell.s.border = {
          top: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } }
        };
        cell.s.fill = {
          patternType: "solid",
          fgColor: { theme: 3, tint: 0.3999755851924192, rgb: "cbcbcb" },
          bgColor: { theme: 7, tint: 0.3999755851924192, rgb: "cbcbcb" }
        };
        cell.s.font = {
          name: "宋体",
          sz: 10,
          bold: true,
          color: {
            rgb: "000"
          }
        };
      }
      const cell_ref = XLSX.utils.encode_cell({ c: C, r: R });
      if (typeof cell.v === "number") {
        cell.t = "n";
      } else if (typeof cell.v === "boolean") {
        cell.t = "b";
      } else {
        cell.t = "s";
      }
      ws[cell_ref] = cell;
    }
  }
  if (range.s.c < 10000000) {
    ws["!ref"] = XLSX.utils.encode_range(range);
  }
  return ws;
}
export default {
  exportToExcel
};



// WEBPACK FOOTER //
// ./src/util/ExcelExportActiveGroup.js